(function () {
  var SCENTS = {
    LB: {
      name: 'Lino Blanco', emoji: '🌿', tagline: 'Fresco · Limpio · Sereno',
      desc: 'Tu energía es de calma y equilibrio. Lino Blanco es fresco como la brisa mediterránea, limpio como ropa recién lavada al sol. Para quienes buscan un hogar despejado y lleno de paz.',
      product: { type:'Tu aroma ideal', title:'Lino Blanco · Vela de Soja', price:'Desde 14,90€', handle:'lino-blanco-vela-de-soja-100-vegetal-tres-tamaos-diferentes', img:'https://cdn.shopify.com/s/files/1/1059/8006/8185/files/LINO-BLANCO-TODAS.jpg' },
      pack: { type:'Completa la experiencia', title:'Home Ritual · Lino Blanco', price:'Vela + Home Spray · 26,90€', handle:'home-ritual-lino-blanco-vela-home-spray', img:'https://cdn.shopify.com/s/files/1/1059/8006/8185/files/LINO-BLANCO-MEDIANA.jpg' }
    },
    PO: {
      name: 'Poetic', emoji: '🌸', tagline: 'Floral · Romántico · Delicado',
      desc: 'Eres romántica y soñadora. Poetic es un abrazo floral suave, como un jardín en primavera al amanecer. Eleva cada momento cotidiano a algo especial e inolvidable.',
      product: { type:'Tu aroma ideal', title:'Poetic · Vela de Soja', price:'Desde 14,90€', handle:'poetic-vela-de-soja-100-vegetal-tres-tamaos-diferentes', img:'https://cdn.shopify.com/s/files/1/1059/8006/8185/files/POETIC-TODAS_26f0918d-fc63-4a50-9b2d-0e0846c9f0e9.jpg' },
      pack: { type:'Completa la experiencia', title:'Home Ritual · Poetic', price:'Vela + Home Spray · 26,90€', handle:'home-ritual-poetic-vela-home-spray', img:'https://cdn.shopify.com/s/files/1/1059/8006/8185/files/POETIC-MEDIANA.jpg' }
    },
    BS: {
      name: 'Bergamota & Sándalo', emoji: '🌲', tagline: 'Cálido · Amaderado · Equilibrado',
      desc: 'Eres introspectiva y conectada con la naturaleza. Bergamota & Sándalo combina la frescura cítrica con la calidez del sándalo. Un aroma que equilibra cuerpo y mente.',
      product: { type:'Tu aroma ideal', title:'Bergamota & Sándalo · Vela de Soja', price:'Desde 14,90€', handle:'bergamota-sndalo-vela-de-soja-100-vegetal-tres-tamaos-diferentes', img:'https://cdn.shopify.com/s/files/1/1059/8006/8185/files/BERGAMOTA-Y-SANDALO-TODAS.jpg' },
      pack: { type:'Completa la experiencia', title:'Home Ritual · Bergamota & Sándalo', price:'Vela + Home Spray · 26,90€', handle:'home-ritual-bergamota-sndalo-vela-home-spray', img:'https://cdn.shopify.com/s/files/1/1059/8006/8185/files/BERGAMOTA-Y-SANDALO-MEDIANA.jpg' }
    },
    DA: {
      name: 'Dark Amber', emoji: '🍂', tagline: 'Sensual · Intenso · Misterioso',
      desc: 'Eres apasionada e intensa. Dark Amber es profundo y envolvente, cálido como el ámbar con un toque de misterio que transforma cualquier espacio en algo irresistible.',
      product: { type:'Tu aroma ideal', title:'Dark Amber · Difusor en Spray', price:'12,90€', handle:'dark-amer-difusor-aromtico-en-spray-250ml', img:'https://cdn.shopify.com/s/files/1/1059/8006/8185/files/DSC06861.jpg' },
      pack: { type:'Completa la experiencia', title:'Home Ritual · Dark Amber', price:'Vela + Home Spray · 26,90€', handle:'home-ritual-dark-amber-vela-home-spray', img:'https://cdn.shopify.com/s/files/1/1059/8006/8185/files/DARK-AMBER-MEDIANA.jpg' }
    },
    WM: {
      name: 'White Melon', emoji: '🍉', tagline: 'Frutal · Fresco · Luminoso',
      desc: 'Eres luminosa y llena de energía. White Melon es fresco, afrutado y alegre, como un verano eterno. Llena tu hogar de buen humor y vitalidad desde el primer momento.',
      product: { type:'Tu aroma ideal', title:'White Melon · Vela de Soja', price:'Desde 14,90€', handle:'white-melon-vela-de-soja-100-vegetal-tres-tamaos-diferentes', img:'https://cdn.shopify.com/s/files/1/1059/8006/8185/files/WHITE-MELON-TODAS.jpg' },
      pack: { type:'Completa la experiencia', title:'Pack Dulce · White Melon + Golden Pop', price:'Dos velas · 27,90€', handle:'pack-dulce-white-melon-golden-pop', img:'https://cdn.shopify.com/s/files/1/1059/8006/8185/files/DULCE-GRANDE.jpg' }
    },
    DN: {
      name: 'Dama de Noche', emoji: '🌙', tagline: 'Floral · Nocturno · Sofisticado',
      desc: 'Eres sofisticada y llena de carácter. Dama de Noche florece al caer la noche: floral, profunda y envolvente. Convierte cualquier velada en algo especial e inolvidable.',
      product: { type:'Tu aroma ideal', title:'Dama de Noche · Vela de Soja', price:'Desde 14,90€', handle:'dama-de-noche-vela-de-soja-100-vegetal-tres-tamaos-diferentes', img:'https://cdn.shopify.com/s/files/1/1059/8006/8185/files/DAMA-DE-NOCHE-TODAS.jpg' },
      pack: { type:'Completa la experiencia', title:'Pack Floral · Dama de Noche + Poetic', price:'Dos velas · 27,90€', handle:'pack-floral-dama-de-noche-poetic', img:'https://cdn.shopify.com/s/files/1/1059/8006/8185/files/FLORAL-GRANDE.jpg' }
    }
  };

  var QS = [
    { q: '¿Cómo describes tu espacio ideal?', opts: [
      { e:'🌿', t:'Minimalista, limpio y con mucha luz natural', s:{LB:3} },
      { e:'🌸', t:'Acogedor y romántico, lleno de flores y velas', s:{PO:2,DN:1} },
      { e:'🕯️', t:'Íntimo y cálido, con maderas y tonos tierra', s:{DA:2,BS:1} },
      { e:'🍋', t:'Luminoso y alegre, lleno de color y vida', s:{WM:3} }
    ]},
    { q: '¿Con qué palabras te identifies más?', opts: [
      { e:'✨', t:'Serena y equilibrada', s:{LB:2,BS:1} },
      { e:'🌹', t:'Romántica y soñadora', s:{PO:2,DN:1} },
      { e:'🔥', t:'Apasionada e intensa', s:{DA:3} },
      { e:'⚡', t:'Energética y espontánea', s:{WM:3} }
    ]},
    { q: '¿Qué paisaje sientes que te define?', opts: [
      { e:'🌊', t:'Costa mediterránea: brisa, sal y cielo azul', s:{LB:2,WM:1} },
      { e:'💜', t:'Campo de lavanda al amanecer', s:{PO:3} },
      { e:'🌲', t:'Bosque templado al caer la tarde', s:{BS:3} },
      { e:'🌙', t:'Jardín nocturno bajo la luna llena', s:{DN:2,DA:1} }
    ]},
    { q: '¿Cuándo te gusta más perfumar tu hogar?', opts: [
      { e:'☀️', t:'Por la mañana, para empezar el día con energía', s:{LB:2,WM:1} },
      { e:'☕', t:'Por la tarde, mientras me relajo o trabajo', s:{BS:2,PO:1} },
      { e:'🌙', t:'Por la noche, para crear un ambiente especial', s:{DA:2,DN:1} },
      { e:'🏡', t:'Siempre: quiero que mi hogar huela bien todo el tiempo', s:{LB:1,PO:1,BS:1} }
    ]},
    { q: '¿Qué sensación buscas al llegar a casa?', opts: [
      { e:'🌬️', t:'Frescor y tranquilidad: resetear el día', s:{LB:3} },
      { e:'🫂', t:'Calidez y protección: sentirme abrazada', s:{BS:2,DA:1} },
      { e:'🌸', t:'Romance y belleza: elevar el ambiente', s:{PO:2,DN:1} },
      { e:'💫', t:'Algo sofisticado que me sorprenda', s:{DN:2,DA:1} }
    ]}
  ];

  var scores = {LB:0,PO:0,BS:0,DA:0,WM:0,DN:0};
  var curQ = 0;
  var LETTERS = ['A','B','C','D'];

  function showStep(id) {
    document.querySelectorAll('.qs').forEach(function(el) { el.classList.remove('qs--active'); });
    var el = document.getElementById(id);
    if (el) el.classList.add('qs--active');
  }

  function isApple() {
    var ua = (navigator.userAgent || '').toLowerCase();
    var pf = (navigator.platform || '').toLowerCase();
    var tp = navigator.maxTouchPoints || 0;
    if (/iphone|ipad|ipod/.test(ua)) return true;
    if (/mac/.test(pf)) return true;
    if (/mac/.test(ua) && tp > 1) return true;
    return false;
  }

  function winner() {
    var best = null, top = -1;
    Object.keys(scores).forEach(function(k) { if (scores[k] > top) { top = scores[k]; best = k; } });
    return best;
  }

  function renderQ() {
    var data = QS[curQ];
    var pct = Math.round((curQ / QS.length) * 100);
    document.getElementById('cqs-prog-label').textContent = 'Pregunta ' + (curQ + 1) + ' de ' + QS.length;
    document.getElementById('cqs-prog-pct').textContent = pct + '%';
    document.getElementById('cqs-prog-bar').style.width = pct + '%';
    var html = '<div class="cqp-qblock"><span class="cqp-qnum">Pregunta ' + (curQ + 1) + '</span><p class="cqp-qtext">' + data.q + '</p></div><div class="cqp-opts">';
    data.opts.forEach(function(opt, i) {
      html += '<button type="button" class="cqp-opt" data-i="' + i + '"><span class="cqp-opt__letter">' + LETTERS[i] + '</span><span>' + opt.e + ' ' + opt.t + '</span></button>';
    });
    html += '</div>';
    var box = document.getElementById('cqs-qcontent');
    box.innerHTML = html;
    box.querySelectorAll('.cqp-opt').forEach(function(btn) {
      btn.addEventListener('click', function() { onSelect(parseInt(this.getAttribute('data-i'), 10), this); });
    });
  }

  function onSelect(i, btn) {
    document.querySelectorAll('#cqs-qcontent .cqp-opt').forEach(function(b) { b.disabled = true; });
    btn.classList.add('cqp-opt--sel');
    var s = QS[curQ].opts[i].s;
    Object.keys(s).forEach(function(k) { scores[k] += s[k]; });
    setTimeout(function() {
      curQ++;
      if (curQ < QS.length) { renderQ(); }
      else { showStep('cqs-loading'); setTimeout(renderResult, 2200); }
    }, 360);
  }

  function card(p) {
    return '<a href="/products/' + p.handle + '" class="cqp-card">'
      + '<img src="' + p.img + '" alt="' + p.title + '" class="cqp-card__img" loading="lazy">'
      + '<div class="cqp-card__body">'
      + '<p class="cqp-card__type">' + p.type + '</p>'
      + '<p class="cqp-card__name">' + p.title + '</p>'
      + '<p class="cqp-card__price">' + p.price + '</p>'
      + '<span class="cqp-card__btn">Ver producto →</span>'
      + '</div></a>';
  }

  function renderResult() {
    var key = winner(), scent = SCENTS[key], apple = isApple();
    var cards = apple
      ? '<div class="cqp-cards cqp-cards--two">' + card(scent.product) + card(scent.pack) + '</div>'
      : '<div class="cqp-cards">' + card(scent.product) + '</div>';
    document.getElementById('cqs-result-inner').innerHTML =
      '<span class="cqp-res__badge">✦ Tu aroma ideal es</span>'
      + '<h2 class="cqp-res__name">' + scent.emoji + ' ' + scent.name + '</h2>'
      + '<p class="cqp-res__tagline">' + scent.tagline + '</p>'
      + '<div class="cqp-res__divider"></div>'
      + '<p class="cqp-res__desc">' + scent.desc + '</p>'
      + cards
      + '<div class="cqp-restart"><button type="button" class="cqp-restart__btn" id="cqs-restart">Volver a empezar</button></div>';
    showStep('cqs-result');
    document.getElementById('cqs-restart').addEventListener('click', restart);
  }

  function restart() {
    scores = {LB:0,PO:0,BS:0,DA:0,WM:0,DN:0};
    curQ = 0;
    showStep('cqs-intro');
  }

  var startBtn = document.getElementById('cqs-start');
  if (startBtn) {
    startBtn.addEventListener('click', function() { showStep('cqs-questions'); renderQ(); });
  }

})();
